import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const names = ['Martina', 'Lucía', 'Camila', 'Sofía', 'Valentina', 'Julieta', 'Florencia', 'Agustina', 'Micaela', 'Rocío'];
const cities = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'Mar del Plata', 'Tucumán', 'Salta', 'Santa Fe', 'Neuquén'];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [purchaseData, setPurchaseData] = useState({
    name: '',
    city: '',
    time: ''
  });
  useEffect(() => {
    const showPopup = () => {
      const randomName = names[Math.floor(Math.random() * names.length)];
      const randomCity = cities[Math.floor(Math.random() * cities.length)];
      const randomTime = Math.floor(Math.random() * 15) + 1; // 1 to 15 minutes ago
      setPurchaseData({
        name: randomName,
        city: randomCity,
        time: `Hace ${randomTime} min`
      });
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 5000); // Hide after 5 seconds
    };
    // Initial delay before first popup
    const initialTimer = setTimeout(showPopup, 10000);
    // Set up interval for subsequent popups
    const interval = setInterval(() => {
      if (!isVisible) {
        showPopup();
      }
    }, 25000); // Show every 25 seconds
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, [isVisible]);
  return <AnimatePresence data-id="element-69">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} className="fixed bottom-4 left-4 right-4 md:left-auto md:right-4 md:w-80 bg-white rounded-lg shadow-xl border border-gray-100 p-4 z-50 flex items-start gap-3" data-id="element-70">
          <div className="bg-emerald-100 p-2 rounded-full flex-shrink-0" data-id="element-71">
            <CheckCircle2 className="w-6 h-6 text-emerald-600" data-id="element-72" />
          </div>
          <div data-id="element-73">
            <p className="text-sm text-gray-800 font-medium" data-id="element-74">
              <span className="font-bold" data-id="element-75">{purchaseData.name}</span> de{' '}
              {purchaseData.city}
            </p>
            <p className="text-xs text-gray-500 mt-1" data-id="element-76">
              Acaba de comprar Arquera de Hockey 360
            </p>
            <p className="text-xs text-emerald-600 font-medium mt-1" data-id="element-77">
              {purchaseData.time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}